import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

import {
  FaFacebook,
  FaYoutube,
  FaTwitter,
  FaLinkedin
} from 'react-icons/fa';
import {
  Box,
  Button,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  AppBar,
  Toolbar,
  useScrollTrigger,
  Slide,
  Fade,
  Zoom,
  Chip,
  Divider,
  Link as MuiLink,
  Stack,
} from '@mui/material';
import {
  Search as SearchIcon,
  Spa as SpaIcon,
  CalendarToday as CalendarIcon,
  Star as StarIcon,
  People as PeopleIcon,
  TrendingUp as TrendingUpIcon,
  ThumbUp as ThumbUpIcon,
  ChevronLeft,
  ChevronRight,
  Facebook,
  Instagram,
  WhatsApp,
  Mail,
  Phone,
  // NotificationsIcon,
} from '@mui/icons-material';

function Footer() {
  return (
    // <div className='footer-container' style={{ zIndex: 1 }}>
    <Box sx={{ bgcolor: '#333', color: 'white', py: 3 }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0 }}>
              GroomWell
            </Typography>
            <Typography variant="body2">
              Connecting you to Style, Seamlessly.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 0 }}>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <MuiLink component={Link} to="/AboutUs" color="inherit" underline="hover">
                About Us
              </MuiLink>
              <MuiLink component={Link} to="/Contact" color="inherit" underline="hover">
                Contact
              </MuiLink>
              <MuiLink component={Link} to="/PrivacyPolicy" color="inherit" underline="hover">
                Privacy Policy
              </MuiLink>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            {/* <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Follow Us
            </Typography>
            <Stack direction="row" spacing={2}>
              <IconButton sx={{ color: 'white' }}>
                <Facebook />
              </IconButton>
              <IconButton sx={{ color: 'white' }}>
                <Instagram />
              </IconButton>
              <IconButton sx={{ color: 'white' }}>
                <WhatsApp />
              </IconButton>
            </Stack> */}
            <Typography variant="body2" sx={{ mt: 1 }}>
              <Phone sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} /> +91-83338 42398 (WhatsApp)
              <br />
              <Mail sx={{ fontSize: 16, verticalAlign: 'middle', mr: 0.5 }} /> support@groomwell.in
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ bgcolor: 'rgba(255,255,255,0.1)', my: 1 }} />
        <Typography variant="body2" align="center">
          © 2025 GroomWell Digital Services. All rights reserved.
        </Typography>
      </Container>
    </Box>

  )
}

export default Footer;


{/* <div className='social-media-wrap'>
        <div className='footer-logo' style={{ zIndex: 1 }}>
          <Link to='/' className='social-logo'>
            <img src="assets/GroomWell-Emblem.png" alt="NoImg" style={{ width: 50, height: 50, zIndex: 1 }} />
            GroomWell
          </Link>
        </div>
        <small className='website-rights'>GroomWell Digital Services © 2025</small>
        <div className='social-icons'>
          <Link
            className='social-icon-link'
            to='/'
            target='_blank'
            aria-label='Facebook'
          >
            <FaFacebook />
          </Link>
          <Link
            className='social-icon-link'
            to={
              '/'
            }
            target='_blank'
            aria-label='Youtube'
          >
            <FaYoutube />
          </Link>
          <Link
            className='social-icon-link'
            to='/'
            target='_blank'
            aria-label='Twitter'
          >
            <FaTwitter />
          </Link>
          <Link
            className='social-icon-link'
            to='/'
            target='_blank'
            aria-label='LinkedIn'
          >
            <FaLinkedin />
          </Link>
          <Link
            to={'/PrivacyPolicy'}
            color='black'

          >
            Privacy Policy
          </Link>

        </div>
      </div> */}
// </div>